<template>
  <span :style="styleObject" class="df-skeleton-animated df-skeleton-image"></span>
</template>

<script>
  export default {
    props: {
      styleObject: {
        type: Object,
        default: null
      }
    },
  }
</script>
<style lang="less" scoped>
@375: 320/375;
ul,
li {
  list-style: none;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.df-skeleton {
  display: block;
  width: 100%;
  margin: 10px * @375 0;
  padding: 15px * @375 10px * @375;
  background-color: #fff;
  border-radius: 0;
  &-content {
    padding: 15px * @375 10px * @375;
  }
  &-image {
    display: block;
    width: 100%;
    height: 95px * @375;
    background-color: rgba(247, 247, 247, 1);
  }

  &-paragraph {
    &-line {
      width: 100%;
      height: 18px * @375;
      margin-bottom: 8px * @375;
      background-color: rgba(247, 247, 247, 1);
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &-goodsList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }
}

.df-skeleton-animated {
  .df-skeleton-paragraph-line,
  .df-skeleton-image {
    position: relative;
    z-index: 0;
    overflow: hidden;
    &::after {
      position: absolute;
      top: 0;
      right: -150%;
      bottom: 0;
      left: -150%;
      background: linear-gradient(
        90deg,
        rgba(190, 190, 190, 0.2) 25%,
        rgba(129, 129, 129, 0.24) 37%,
        rgba(190, 190, 190, 0.2) 63%
      );
      animation: df-skeleton-loading 1.4s ease infinite;
      content: '';
    }
  }
}
.df-skeleton-animated.df-skeleton-image {
  position: relative;
  z-index: 0;
  overflow: hidden;
  &::after {
    position: absolute;
    top: 0;
    right: -150%;
    bottom: 0;
    left: -150%;
    background: linear-gradient(
      90deg,
      rgba(190, 190, 190, 0.2) 25%,
      rgba(129, 129, 129, 0.24) 37%,
      rgba(190, 190, 190, 0.2) 63%
    );
    animation: df-skeleton-loading 1.4s ease infinite;
    content: '';
  }
}

.df-skeleton-round {
  border-radius: 4px * @375;
}

@keyframes df-skeleton-loading {
  0% {
    transform: translateX(-37.5%);
  }

  100% {
    transform: translateX(37.5%);
  }
}
</style>
